<!-- Add/Edit Article Modal -->
<div class="modal-header">
    <h5 class="modal-title" id="editArticleTitle">Edit Article</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-6 mb-3">
            <label for="articleType" class="form-label">Image Layout</label>
            <div class="row">
                <div class="col-12 text-center">
                    <div class="btn-group paymentSelect w-100" role="group"
                         aria-label="Image Layout">
                        <input [value]="false" [(ngModel)]="newsInfo.isPortrait"
                               type="radio" class="btn-check" name="btnPaymentSelect"
                               id="btnPaymentSelect1" autocomplete="off">
                        <label class="btn btn-outline-primary" for="btnPaymentSelect1">
                            Landscape
                        </label>
                        <input [value]="true" [(ngModel)]="newsInfo.isPortrait"
                               type="radio" class="btn-check" name="btnPaymentSelect"
                               id="btnPaymentSelect2" autocomplete="off">
                        <label class="btn btn-outline-primary" for="btnPaymentSelect2">
                            Portrait
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="newsInfo.articleType == 1">
        <div class="col-12 mb-3">
            <label for="runDate" class="form-label">Run Date</label>
            <input class="form-control" type="text" id="runDate" [(ngModel)]="newsInfo.runDate">
        </div>
    </div>
    <div class="row">
        <div class="col-12 mb-3">
            <label for="articleTitle" class="form-label">Article Title</label>
            <input type="text" class="form-control" id="articleTitle" [(ngModel)]="newsInfo.articleTitle" placeholder="Article Title">
        </div>
    </div>
    <div class="row">
        <div class="col-12 mb-3">
            <label for="articleImg" class="form-label">Article Image</label>
            <input class="form-control" type="file" id="articleImg" (change)="updateImage($event.target.files)">
        </div>
    </div>
    <div class="row">
        <div class="col-12 mb-3">
            <label for="articleContent" class="form-label">Article Content</label>
            <!--<textarea [(ngModel)]="newsInfo.articleContent" class="form-control" id="articleContent" rows="10"></textarea>-->
            <editor [(ngModel)]="newsInfo.articleContent" class="form-control" initialValue="newsInfo.articleContent" licenseKey="gpl" [init]="{
                base_url: '/tinymce',
                suffix: '.min',
                statusbar: false,
                menubar: false,
                toolbar: 'undo redo | image link | bold italic | alignleft aligncentre alignright alignjustify | indent outdent | bullist numlist',
                skin: '../../../assets/css/tinymce',
                content_style: 'body { color: #FFFFFF; }',
                height: 350,
                plugins: 'link lists',
            }"></editor>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" (click)="update()" class="btn btn-sb border-lb text-strong text-uppercase m-100">Save</button>
    <button type="button" class="btn btn-cancel text-strong text-uppercase m-100" (click)="dismiss()">Cancel</button>
</div>